import React from "react"

export const pageTitle = "Casambi Ecosystem Integration"
export const pageMetadata =
  "Pushfusion works with the Casambi API to bring data from your local Casambi networks together in one stunning dashboard. It doesn’t matter where they are, or where you are, you can access insights, analysis and reports anywhere at the click of a button."

export const title = "Casambi"
export const subtitle = "Integration"
export const description = [
  {
    bold: false,
    text: (
      <>
        <span className="text-blue-50 font-bold">push</span>
        <span className="text-pushfusion font-extrabold">fusion</span> brings
        performance and monitoring data from your local Casambi networks
        together in one place allowing you to manage your estate effectively
        from anywhere in the world.
      </>
    ),
  },
]
